import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import LabelSelectRow from "./LabelSelectRow";
import { YES_NO_OPTIONS } from "../constants";
import { Typography } from "@mui/material";

export const InvoiceDeliveryDateSection = () => {
  const { t } = useTranslation("customers");
  return (
    <FormSection title={t("contract.invoiceDeliveryDate")}>
      <Typography variant="secondary" padding="1rem">
        {t("contract.invoiceDeliveryDateGuideText")}
      </Typography>
      <LabelSelectRow
        label={t("contract.deliveryDateEnabled")}
        fieldName="invoiceDeliveryDateEnabled"
        options={YES_NO_OPTIONS}
        getDisplayValue={(val) => (val ? t(`common:${val}`) : "")}
        selectWidth={2}
      />
    </FormSection>
  );
};
